import React from 'react';
import classNames from 'classnames';
import { string, oneOfType, oneOf } from 'prop-types';

import { ResponsiveImage } from '../../components';
import { propTypes } from '../../util/types';
import superhostBadgeImg from '../ListingCard/images/superhostBadge.png';

import css from './SuperhostBadge.module.css';

const AVATAR_VARIANTS = ['square-small', 'square-small2x'];

const SIZE_CLASS = {
  xsmall: css.xsmall,
  small: css.small,
  medium: css.medium,
  large: css.large,
  compact: css.compact,
  default: css.default,
  fill: css.fill,
};

const IMAGE_SIZES = {
  xsmall: '32px',
  small: '40px',
  medium: '60px',
  large: '96px',
  compact: '56px',
  default: '64px',
  fill: '240px',
};

const SuperhostBadge = props => {
  const { user, label, className, size, initials } = props;
  const profileImage = user?.profileImage;
  const hasAvatar = !!(profileImage && profileImage.id);
  const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.default;
  const classes = classNames(css.root, sizeClass, className);

  return (
    <div className={classes} title={label} aria-label={label}>
      <div className={css.disc} />
      <img className={css.badgeImg} src={superhostBadgeImg} alt="" aria-hidden="true" />
      {hasAvatar || initials ? (
        <div className={css.avatarWrap}>
          {hasAvatar ? (
            <ResponsiveImage
              rootClassName={css.avatarImg}
              alt={label}
              image={profileImage}
              variants={AVATAR_VARIANTS}
              sizes={IMAGE_SIZES[size] || IMAGE_SIZES.default}
            />
          ) : (
            <span className={css.initials}>{initials}</span>
          )}
        </div>
      ) : null}
    </div>
  );
};

SuperhostBadge.defaultProps = {
  className: null,
  size: 'default',
  initials: null,
};

SuperhostBadge.propTypes = {
  user: oneOfType([propTypes.user, propTypes.currentUser]),
  label: string.isRequired,
  className: string,
  size: oneOf(['xsmall', 'small', 'medium', 'large', 'compact', 'default', 'fill']),
  initials: string,
};

export default SuperhostBadge;
